import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectOfferDO } from '../../../../../../system/system-dtos';
import { isDefined } from '../../../../../utils/utils';

interface Code {
  html: string;
  javascript: string;
  css: string;
  data: any;
}

@Component({
  selector: 'app-form-field-code-pen',
  templateUrl: './code-pen-form-field.component.html',
  styleUrls: ['./code-pen-form-field.component.scss'],
  standalone: false,
})
export class CodePenFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  modelHtmlData: any;

  modelJsData: any;

  modelCssData: any;

  modelDataData: any;

  lineNumbers = true;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnInit() {
    const code = isDefined(this.data)
      ? (this.data as Code)
      : ({
          html: '',
          javascript: '',
          css: '',
          data: '',
        } as Code);

    this.modelHtmlData = isDefined(code.html) ? code.html : '';
    this.modelJsData = isDefined(code.javascript) ? code.javascript : '';
    this.modelCssData = isDefined(code.css) ? code.css : '';
    this.modelDataData = isDefined(code.data) ? code.data : '';
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {}

  onModelChange() {
    if (this.formGroup) {
      const newData: Code = {
        html: isDefined(this.modelHtmlData) ? this.modelHtmlData : '',
        javascript: isDefined(this.modelJsData) ? this.modelJsData : '',
        css: isDefined(this.modelCssData) ? this.modelCssData : '',
        data: isDefined(this.modelDataData) ? this.modelDataData : '',
      };
      this.formGroup.get(this.fieldConfig.name).setValue(newData);
    }
  }
}
